import { LanguageList } from "./../../../i18next/config";
import i18next from "i18next";

i18next.addResources(LanguageList.SPANISH, "ProfileRole", {
    continue: "Continuar"
});

i18next.addResources(LanguageList.ENGLISH, "ProfileRole", {
    continue: "Continue"
});
